import { CreativeMapping, CreativeMappings } from "../creativeMappings";
import { CreativeMappingsRuleForm } from "validation/components/CreativeMappings/creativeMappingsRules";
import { remapFilters, remapViewFilters } from "./ulits.factory";

export const buildCreativeMappingsViewModel = (mappings: CreativeMappings[]): CreativeMappingsRuleForm[] => {
    return mappings.map(({ id, creatives, filters }) => {
        return {
            id,
            isEdited: false,
            filters: remapViewFilters(filters),
            creatives: creatives.map((creative) => {
                return {
                    target: creative.target,
                    width: creative.width.toString(),
                    height: creative.height.toString(),
                };
            }),
        };
    });
};

export const buildCreativeMappingModel = ({
    id,
    filters,
    creatives,
}: CreativeMappingsRuleForm): CreativeMapping & { id?: number } => {
    return {
        id,
        filters: remapFilters(filters),
        creatives: creatives.map((creative) => {
            return {
                target: creative.target,
                width: parseFloat(creative.width),
                height: parseFloat(creative.height),
            };
        }),
    };
};
